export const CHAT_MESSAGES = {
  recommendationLoading: '',

  recommendationUnavailable: '',

  recommendationFailed: '',

  routineFailed: '',

  metadataSubmissionFailed: '',
  validationFailed: '',

  validationClarificationFallback: '',

  hairPredictionRetry: '',

  hairPredictionManualSelection: '',

  hairPredictionManualSelection: '',

  segmentedHairImage: '',

  recommendationReady: '',
}
